import { Button, DialogActions, FormControl, TextField, Drawer, Typography, Divider } from '@mui/material'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';

const MsmqHeaderFields = ({ open, handleClose, connectionDetails, valuesHandler, disableControl }) => {
    const [headers, setHeaders] = useState({});
    const [workflowSessionModal, setWorkflowSessionModal] = useState({ open: false, isFirstTime: false });
    const [valueLabel, setValueLabel] = useState("");

    useEffect(() => {
        setHeaders({
            ACK: connectionDetails?.ACK || '',
            APPSPECIFIC: connectionDetails?.APPSPECIFIC || '',
            AUTHLEVEL: connectionDetails?.AUTHLEVEL || '',
            DELIVERY: connectionDetails?.DELIVERY || '',
            JOURNAL: connectionDetails?.JOURNAL || '',
            LABEL: connectionDetails?.LABEL || '',
            MAXTIMETOREACHQUEUE: connectionDetails?.MAXTIMETOREACHQUEUE || '',
            MAXTIMETORECEIVE: connectionDetails?.MAXTIMETORECEIVE || '',
            PRIORITY: connectionDetails?.PRIORITY || '',
            PRIVLEVEL: connectionDetails?.PRIVLEVEL || '',
            TRACE: connectionDetails?.TRACE || '',
            HASHALGORITHM: connectionDetails?.HASHALGORITHM || '',
        })
    }, [connectionDetails, open]);

    const onInputChange = (name, value) => {
        setHeaders(prev => ({ ...prev, [name]: value }));
    }

    const handleDone = () => {
        valuesHandler(headers);
    }

    const fields = [
        { label: "LBL_MSMQ_ACK", key: "ACK" }, 
        { label: "LBL_MSMQ_APPSPECIFIC", key: "APPSPECIFIC" },
        { label: "LBL_MSMQ_AUTHLEVEL", key: "AUTHLEVEL" }, 
        { label: "LBL_MSMQ_DELIVERY", key: "DELIVERY" },
        { label: "LBL_MSMQ_JOURNAL", key: "JOURNAL" }, 
        { label: "LBL_MSMQ_LABEL", key: "LABEL" },
        { label: "LBL_MSMQ_MAXTIMETOREACHQUEUE", key: "MAXTIMETOREACHQUEUE" }, 
        { label: "LBL_MSMQ_MAXTIMETORECEIVE", key: "MAXTIMETORECEIVE" },
        { label: "LBL_MSMQ_PRIORITY", key: "PRIORITY" }, 
        { label: "LBL_MSMQ_PRIVLEVEL", key: "PRIVLEVEL" },
        { label: "LBL_MSMQ_TRACE", key: "TRACE" }, 
        { label: "LBL_MSMQ_HASHALGORITHM", key: "HASHALGORITHM" },
    ]

    return (
        <Drawer
            anchor="left"
            open={open}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    width: '400px',
                    padding: '5px 10px 0px 10px',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <div>
                <div className='flex justify-between items-center'>
                    <div>
                        <Typography variant='h6'>{t('LBL_MSMQ_HEADER_HEADING')}</Typography>
                        <Typography variant='body2'>{t('LBL_MSMQ_HEADER_DESC')}</Typography>
                    </div>
                </div>
                <Divider sx={{ my: 2 }} />
            </div>

            <div style={{ flex: '1 1 auto', overflowY: 'auto' }}>
                <div className='grid grid-cols-1 gap-4'>
                    {fields.map(field => (
                        <FormControl className="width-100" sx={{ mb: 2 }} size="small" key={field.key}>
                            <div style={{display:'flex', gap:'4px'}}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t(field.label)}
                                    type="text"
                                    value={headers[field.key] || ''}
                                    onChange={(e) => setHeaders(prev => ({ ...prev, [field.key]: e.target.value }))}
                                    className={"width-100"}
                                    name={field.key}
                                    autoComplete="off"
                                    disabled={disableControl}
                                />
                                <Button
                                    size="small"
                                    disabled={disableControl || false}
                                    variant="outlined"
                                    onClick={() => {
                                        setValueLabel(t(field.label));
                                        setWorkflowSessionModal({ open: true, isFirstTime: true });
                                    }}
                                    sx={{ width: "40px", minWidth: "40px" }}>
                                    <MoreHorizOutlined fontSize="small" />
                                </Button>
                            </div>
                        </FormControl>
                    ))}
                </div>
            </div>

            <DialogActions>
                <Button variant='outlined' onClick={handleClose} color="primary">{t('BTN_CLOSE')}</Button>
                <Button variant='outlined' onClick={handleDone} color="primary" disabled={disableControl}>{t('BTN_DONE')}</Button>
            </DialogActions>
            
            <WorkflowSessionModal
                valueLabel={valueLabel}
                showAccountData={true}
                showCallingWorkflow={true}
                showSystemData={true}
                showWorkflowSession={true}
                showDateAndTime={true}
                openModal={workflowSessionModal}
                setModalOpen={setWorkflowSessionModal}
                handleClose={() =>
                    setWorkflowSessionModal({ open: false, isFirstTime: false })
                }
                initialValue={
                    valueLabel === t("LBL_MSMQ_ACK")
                        ? headers["ACK"]
                        : valueLabel === t("LBL_MSMQ_APPSPECIFIC")
                        ? headers["APPSPECIFIC"]
                        : valueLabel === t("LBL_MSMQ_AUTHLEVEL")
                        ? headers["AUTHLEVEL"]
                        : valueLabel === t("LBL_MSMQ_DELIVERY")
                        ? headers["DELIVERY"]
                        : valueLabel === t("LBL_MSMQ_JOURNAL")
                        ? headers["JOURNAL"]
                        : valueLabel === t("LBL_MSMQ_LABEL")
                        ? headers["LABEL"]
                        : valueLabel === t("LBL_MSMQ_MAXTIMETOREACHQUEUE")
                        ? headers["MAXTIMETOREACHQUEUE"]
                        : valueLabel === t("LBL_MSMQ_MAXTIMETORECEIVE")
                        ? headers["MAXTIMETORECEIVE"]
                        : valueLabel === t("LBL_MSMQ_PRIORITY")
                        ? headers["PRIORITY"]
                        : valueLabel === t("LBL_MSMQ_PRIVLEVEL")
                        ? headers["PRIVLEVEL"]
                        : valueLabel === t("LBL_MSMQ_TRACE")
                        ? headers["TRACE"]
                        : valueLabel === t("LBL_MSMQ_HASHALGORITHM")
                        ? headers["HASHALGORITHM"]
                        : ""
                }
                valuesHandler={(value) => {
                    if (valueLabel === t("LBL_MSMQ_ACK")) {
                       setHeaders(prev => ({ ...prev, ACK: value }));
                    } else if (valueLabel === t("LBL_MSMQ_APPSPECIFIC")) {
                        setHeaders(prev => ({ ...prev, APPSPECIFIC: value }));
                    } else if (valueLabel === t("LBL_MSMQ_AUTHLEVEL")) {
                        setHeaders(prev => ({ ...prev, AUTHLEVEL: value }));
                    } else if (valueLabel === t("LBL_MSMQ_DELIVERY")) {
                        setHeaders(prev => ({ ...prev, DELIVERY: value }));
                    } else if (valueLabel === t("LBL_MSMQ_JOURNAL")) {
                        setHeaders(prev => ({ ...prev, JOURNAL: value }));
                    } else if (valueLabel === t("LBL_MSMQ_LABEL")) {
                        setHeaders(prev => ({ ...prev, LABEL: value }));
                    } else if (valueLabel === t("LBL_MSMQ_MAXTIMETOREACHQUEUE")) {
                        setHeaders(prev => ({ ...prev, MAXTIMETOREACHQUEUE: value }));
                    } else if (valueLabel === t("LBL_MSMQ_MAXTIMETORECEIVE")) {
                        setHeaders(prev => ({ ...prev, MAXTIMETORECEIVE: value }));
                    } else if (valueLabel === t("LBL_MSMQ_PRIORITY")) {
                        setHeaders(prev => ({ ...prev, PRIORITY: value }));
                    } else if (valueLabel === t("LBL_MSMQ_PRIVLEVEL")) {
                        setHeaders(prev => ({ ...prev, PRIVLEVEL: value }));
                    } else if (valueLabel === t("LBL_MSMQ_TRACE")) {
                        setHeaders(prev => ({ ...prev, TRACE: value }));
                    } else if (valueLabel === t("LBL_MSMQ_HASHALGORITHM")) {
                        setHeaders(prev => ({ ...prev, HASHALGORITHM: value }));
                    }
                }}
            />
        </Drawer>
    )
}

export default MsmqHeaderFields; 